import React from 'react';
import { UploadSVG } from '../../@common_components/svgs/upload.svg';

const UploadIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return <UploadSVG {...props} />;
};

export { UploadIcon };
